// extracted by mini-css-extract-plugin
module.exports = {"content":"content___1Pc67","contentLeft":"contentLeft___3t5kH","contentRight":"contentRight___2AKg7","previewCard":"previewCard___3uDYE","imgPreview":"imgPreview___vNUBu"};